import React from 'react'

const Chevron = ({ className }) => (
  <svg
    className={className}
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.972656 1.77148L5.47266 6.27148C5.61328 6.42383 5.78906 6.5 6 6.5C6.21094 6.5 6.38672 6.42383 6.52734 6.27148L11.0273 1.77148C11.1797 1.63086 11.2559 1.46094 11.2559 1.26172C11.2559 1.05078 11.1797 0.869141 11.0273 0.716797C10.8867 0.576172 10.7109 0.505859 10.5 0.505859C10.2891 0.505859 10.1133 0.576172 9.97266 0.716797L6 4.68945L2.02734 0.716797C1.88672 0.576172 1.71094 0.505859 1.5 0.505859C1.28906 0.505859 1.11328 0.576172 0.972656 0.716797C0.820313 0.869141 0.744141 1.05078 0.744141 1.26172C0.744141 1.46094 0.820313 1.63086 0.972656 1.77148Z"
      fill="currentColor"
    />
  </svg>
)

export default Chevron
